export enum FEATURED_FEEDBACK_CARD_TYPE {
  GIVE_FEEDBACK,
  BUG_REPORT,
}

export enum UserReportOption {
  FEEDBACK = 'feedback',
  REPORT_BUG = 'report-bug',
  LEAVE_FEEDBACK = 'leave-feedback',
  FEEDBACK_FORUM = 'feedback-forum',
}
